// extracted by mini-css-extract-plugin
export default {"groceries-list":"GroceriesList_groceries-list__81SJk","groceries-list__fallback":"GroceriesList_groceries-list__fallback__gaF82"};